import _ from 'lodash';
import moment from 'moment';

export const formatString = 'MM/DD/YYYY';
export const formatDbString = 'MMM, DD YYYY HH:mm:ss';
export const dpswRolloutDate = moment('10/29/2018', formatString);

export const formatDate = dateString => {
  if (_.isEmpty(dateString)) return moment().format(formatString);
  return moment(dateString, formatDbString).format(formatString);
};

export const toMomentDate = dateString => {
  if (_.isEmpty(dateString)) return moment();
  return moment(dateString, formatDbString);
};

export const addDays = (momentDate, days) => {
  if (_.isEmpty(momentDate)) return moment();
  return moment(momentDate).add(days, 'days');
};

export const checkDPSW = dateString => {
  if (_.isEmpty(dateString)) return false;
  return dpswRolloutDate < toMomentDate(dateString);
};



// WEBPACK FOOTER //
// ./src/helpers/DateHelper.js